import type {z} from "zod";

import {AddRepresentativeNoteBody} from "@project/sdk/sales/zod";

import {requiredStringSchema} from "../../../../../../../shared/validation/required-string.schema";
import {noteFieldLabelIds} from "../../../../../../../support/messages/note.messages";

export const addRepresentativeNoteTitleSchema = requiredStringSchema(
  AddRepresentativeNoteBody.shape.title,
  noteFieldLabelIds.title,
);
export const addRepresentativeNoteContentSchema = requiredStringSchema(
  AddRepresentativeNoteBody.shape.content,
  noteFieldLabelIds.content,
);

export const addRepresentativeNoteFormSchema = AddRepresentativeNoteBody.extend({
  title: addRepresentativeNoteTitleSchema,
  content: addRepresentativeNoteContentSchema,
});
export type AddRepresentativeNoteFormPayload = z.output<typeof addRepresentativeNoteFormSchema>;

export const draftAddRepresentativeNoteFormSchema = addRepresentativeNoteFormSchema.partial();
export type DraftAddRepresentativeNoteFormPayload = z.output<
  typeof draftAddRepresentativeNoteFormSchema
>;
